var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { CommonModal } from '@appspotr/ui-kit';
var DeleteConfirmationModal = function (_a) {
    var active = _a.active, selectedEntities = _a.selectedEntities, onCancel = _a.onCancel, onConfirm = _a.onConfirm, pushTemplates = _a.pushTemplates, patchesConnectedToHome = _a.patchesConnectedToHome, _b = _a.isPatchDeletion, isPatchDeletion = _b === void 0 ? false : _b;
    // Freeze the value at mount time to prevent flickering during async delete
    // (selectedPatches can clear before the modal finishes closing)
    var isPatchDeletionFrozen = useRef(isPatchDeletion);
    var patchCount = selectedEntities === null || selectedEntities === void 0 ? void 0 : selectedEntities.length;
    var pushTemplatesUsingSelectedPatch = 0;
    selectedEntities.map(function (id) {
        var isConnectedToHome = Boolean(patchesConnectedToHome.find(function (p) { return p.id === id; }));
        var templatesUsingCurrentPatch = pushTemplates.filter(function (t) { return t.view_patch === id; }).length;
        pushTemplatesUsingSelectedPatch = isConnectedToHome
            ? pushTemplatesUsingSelectedPatch + templatesUsingCurrentPatch
            : pushTemplatesUsingSelectedPatch;
    });
    var entity = isPatchDeletionFrozen.current ? 'patch' : 'edge';
    return (_jsx(CommonModal, __assign({ active: active, title: "Delete ".concat(patchCount > 1 ? "".concat(entity, "s") : "".concat(entity)), modalType: "delete", disabled: false, cancel: "Cancel", action: "Delete", onClick: onConfirm, hideModal: onCancel }, { children: _jsxs(_Fragment, { children: [Boolean(pushTemplatesUsingSelectedPatch) &&
                    isPatchDeletionFrozen.current && (_jsxs(_Fragment, { children: ["There are/is ", pushTemplatesUsingSelectedPatch, " Push template(s) are using selected patch/patches.", _jsx("br", {})] })), "Are you sure you want to delete the selected ".concat(patchCount > 1 ? "".concat(patchCount, " ").concat(entity, "es") : "".concat(entity), "?")] }) })));
};
export default DeleteConfirmationModal;
